module.exports = __webpack_public_path__ + "static/sec5-bg-sm-d9c55be694111d7d5051ccd8f513ba13.jpg";